import React from 'react'
import { Box, LinearProgress, Typography } from '@mui/material'
import { formatPercentage } from '@ui-seeker/utils'
import { dsColorNew } from '@palette'


export default function AppLinearProgress(
	{
		actual,
		total,
		displayNumbers = true,
		color = "primary",
		highlighted = false,
		generating = false,
		variant='determinate',
		...props
	}) {
	const finish = actual >= total
	const percentage = (actual * 100) / total

	if (actual === null) return <></>

	return <Box sx={{ display: 'flex', alignItems: 'center', width: 1, ...props?.containerProps }}>
		<Box sx={{ width: '100%', mr: .5, ...props?.progressBarContainerProps }}>
			<LinearProgress variant="determinate" value={percentage}
							color={finish ? generating ? "warning" : "success" : color}
							sx={{
								// while it runs, the app blue of the Real Time progress
								...(!finish && color === 'primary' && { '& .MuiLinearProgress-bar': { backgroundColor: dsColorNew.appBlue } }),
								...props?.progressBarProps,
							}}/>
		</Box>
		{!!displayNumbers && !isNaN(percentage) && <Box sx={{ ...props.containerPercentageProps }}>
			<Typography variant={highlighted ? 'subtitle1' : 'body2'}
						color={highlighted ? "text.primary" : "text.secondary"} sx={{ ...props?.percentageProps }}>
				{!generating && formatPercentage(percentage)}
			</Typography>
		</Box>}
	</Box>
}